import { CSSProperties, FC, useMemo } from "react";
import Avatar, { AvatarSize } from "./Avatar/Avatar";
import "./MisceleniousStyles.css";

interface IPersonLineDisplay {
    name: string;
    userId?: number;
    style?: CSSProperties;
    filter?: string;
    textStyle?: CSSProperties;
}

const PersonLineDisplay: FC<IPersonLineDisplay> = ({ 
    name, 
    userId, 
    style, 
    filter, 
    textStyle 
}) => {
    const highlightName = useMemo(() => {
        if (!filter || !name) return name;

        const lowerCaseName = name.toLowerCase();
        const lowerCaseFilter = filter.toLowerCase();
        const startIndex = lowerCaseName.indexOf(lowerCaseFilter);

        if (startIndex === -1) return name;

        return (
            <>
                {name.substring(0, startIndex)}
                <mark className="line-person-display-marker">
                    {name.substring(startIndex, startIndex + filter.length)}
                </mark>
                {name.substring(startIndex + filter.length)}
            </>
        );
    }, [name, filter]);

    const containerStyle = useMemo(() => ({
        ...style
    }), [style]);

    const textContainerStyle = useMemo(() => ({
        ...textStyle
    }), [textStyle]);

    return (
        <div 
            style={containerStyle} 
            className="line-person-display-widget nonselectable"
        >
            <div className="line-profile-image-container">
                <Avatar size={AvatarSize.s} userId={userId} />
            </div>
            <div 
                style={textContainerStyle} 
                title={name} 
                className="task-type-text-elipses"
            >
                <span>{highlightName}</span>
            </div>
        </div>
    );
};

export default PersonLineDisplay;